const urlRoot = '/delay-repay';

export const URL = {
    subscribe: `${urlRoot}/auto/subscribe`,
};



// WEBPACK FOOTER //
// ./src/helpers/DelayRepayEndpoint.js